module.exports = __webpack_public_path__ + "img/sdc_logo_landscape.ca867ca6.png";